// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/Payments';
import {
    cardPayment,
    subscribe,
    setForm,
    getDiscount,
    getPaymentMethods,
    getPayPalParams,
    resetVoucherValue,
} from '../../actions';
import { isSubscription } from '../../utils/helpers';
import { getSelectedFee } from '../../selectors/accessFees';
import { reduxForm } from 'redux-form';
import payform from 'payform';
import { PRICE_OPTS_FORM, PAYMENT_PROCESSOR_FORM } from '../../constants/forms';

type Props = {
    clientID: string,
    selectedFee: Object,
    assetID: number,
    paymentMethod: number,
    language: string,
    title: string,
    discount: Object,
    branding: Object,
    params: Object,
    cardPayment: Function,
    subscribe: Function,
    handleSubmit: Function,
    setForm: Function,
    getDiscount: Function,
    getPaymentMethods: Function,
    getPayPalParams: Function,
    resetVoucherValue: Function,
};

const validate = (values: Object) => {
    const errors = {};

    if (!payform.validateCardNumber(values.cardNumber)) {
        errors.cardNumber = 'Invalid card number.';
    }

    if (!values.cardName) {
        errors.cardName = 'Required';
    }

    if (!values.expiry) {
        errors.expiry = 'Required';
    } else {
        const expiry = payform.parseCardExpiry(values.expiry);
        if (!payform.validateCardExpiry(expiry.month, expiry.year)) {
            errors.expiry = 'Invalid card expiry.';
        }
    }

    if (!payform.validateCardCVC(values.cvc)) {
        errors.cvc = 'Invalid cvc.';
    }

    return errors;
};

export class Payments extends Component<Props> {
    componentDidMount() {
        this.props.getPaymentMethods();
    }

    handleSubmit = (data: Object, {}) => {
        const { assetID, selectedFee, paymentMethod } = this.props;
        const { cardNumber, cardName, expiry, cvc } = data;
        const expiryValue = expiry ? payform.parseCardExpiry(expiry) : expiry;

        const paymentObj = {
            assetID,
            selectedFee,
            paymentMethod,
            referrer: window.location.origin, // referrer
            cardNumber: cardNumber || '',
            cardName: cardName || '',
            expiryValue: expiryValue || '',
            cvc: cvc || '',
        };

        if (voucher) {
            paymentObj.voucherCode = voucher.value;
        }
        if (selectedMethod.value === 'paypal')
            return this.paypalPayment(voucher ? voucher.value : '');
        else {
            this.props.setForm(PAYMENT_PROCESSOR_FORM);

            if (isSubscription(selectedFee)) {
                return this.props.subscribe(paymentObj);
            }

            return this.props.cardPayment(paymentObj);
        }
    };

    handleBack = () => {
        this.props.resetVoucherValue();
        this.props.setForm(PRICE_OPTS_FORM);
    };

    paypalPayment = voucher => {
        this.props.getPayPalParams(this.props.selectedFee.id, voucher);
    };

    render() {
        const {
            handleSubmit,
            language,
            selectedFee,
            title,
            discount,
            branding,
            params,
            payment,
        } = this.props;

        return (
            <Form
                onSubmit={handleSubmit(this.handleSubmit)}
                handleBack={this.handleBack}
                lng={language}
                title={title}
                selectedFee={selectedFee}
                clientID={this.props.clientID}
                getDiscount={this.props.getDiscount}
                discount={discount}
                payment={payment}
                paypalPayment={this.paypalPayment}
                branding={branding}
                params={params}
                resetVoucherValue={this.props.resetVoucherValue}
                dispatch={this.props.dispatch}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        assetID: state.modal.assetID,
        paymentMethod: state.paywall.paymentMethod,
        clientID: state.paywall.clientID,
        selectedFee: getSelectedFee(state),
        title: state.assets[state.modal.assetID].title,
        payment: state.payments,
        language: state.auth.language,
        token: state.auth.token,
        discount: state.discount,
        branding: state.branding,
        params: state.form.payment,
    };
};

export default connect(
    mapStateToProps,
    {
        cardPayment,
        subscribe,
        setForm,
        getDiscount,
        getPaymentMethods,
        getPayPalParams,
        resetVoucherValue,
    }
)(reduxForm({ form: 'payment', validate })(Payments));



// WEBPACK FOOTER //
// ./src/containers/Forms/Payments.js